import ShopAuthApi from "@/api/shopAuthApi";

const ShopAuthStore = {
  namespaced: true,
  state: {
    shopAuthData: {
      items: [],
      pageInfo: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
    },
    shopAuthorizeParams: {
      request: JSON.stringify({
        pageInfo: {
          pageIndex: 1,
          pageSize: 10,
        },
      }),
    },
  },
  mutations: {
    setShopAuthData(state, data) {
      state.shopAuthData = data;
    },
    setShopAuthorizeParams(state, data) {
      state.shopAuthorizeParams = data;
    },
  },
  actions: {
    list(ctx, data) {
      const queryParams = {
        ...ctx.state.shopAuthorizeParams,
        ...data,
      };
      ctx.commit("setShopAuthorizeParams", queryParams);
      return ShopAuthApi.list(queryParams).then((res) => {
        ctx.commit("setShopAuthData", res);
      });
    },

    shopAuthorizeDelele(ctx, data) {
      return ShopAuthApi.shopAuthorizeDelete(data);
    },
    updateStatus(ctx, data) {
      return ShopAuthApi.updateStatus(data);
    },
  },
};

export default ShopAuthStore;
